import moment from 'moment'

export class GregorianDate
{
    static MAX_DAYS = 31
    static MAX_MONTHS = 12
    static MAX_YEARS = 9999

    constructor(year, month, day, format = 'YYYY-MM-DD')
    {
        this.date = moment(new Date(year, month - 1, day), format)

        this.validateDate()
    }

    validateDate()
    {
        if(! this.date.isValid())
        {
            throw new Error("Date is invalid")
        }
    }

    format(format = 'YYYY-MM-DD')
    {
        return this.date.format(format)
    }
}
